export const ECOMMERCE_ORDER_TYPE_RITIRO = 'ecommerce_ritiro';
export const ECOMMERCE_ORDER_TYPE_DEFAULT = 'ecommerce';
export const ECOMMERCE_PRODUCT_TYPE_PACCHETTO = 'pacchetto';
export const ECOMMERCE_PRODUCT_TYPE_PACCHETTO_SMART = 'pacchetto_smart';
export const ECOMMERCE_PRODUCT_TYPE_VIRTUALE = 'virtuale';